import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';

import { BaseFormControl } from '../base-control';
import { FormDisplayField } from '../form-field';

@Component({
    standalone: false,
    selector: 'abs-display-field',
    template: `
        <div class="form-group display" [class]="field.cssClass">
            <label *ngIf="field.label && !field.hideLabel">{{ field.label }}</label>
            @if (field.component) {
                <ng-container *ngComponentOutlet="field.component; inputs: inputs"></ng-container>
            } @else if (field.html) {
                <div class="displayValue" [innerHTML]="text"></div>
            } @else {
                <div class="displayValue">{{ text }}</div>
            }
        </div>
    `,
    styles: [
        `
            .form-group.display {
                padding: 4px 20px;
            }

            label {
                display: block;
                font-size: 0.8em;
                opacity: 0.7;
            }
        `
    ]
})
export class DisplayFieldComponent extends BaseFormControl implements OnInit, OnDestroy {
    @Input()
    field: FormDisplayField;

    text = '';
    inputs: Record<string, any> = {};

    private valueSubscription?: Subscription;

    override ngOnInit() {
        super.ngOnInit();

        // Recompute only when the form actually changes. Binding field.render() directly in
        // the template would break the no-methods-in-templates rule, and reacting to the
        // formValue @Input would fire on every change detection cycle, because
        // form.component.ts binds [formValue]="formGroup.value" — a fresh object each time.
        this.valueSubscription = this.formValue$
            .pipe(startWith(this.parentFormGroup.root.value))
            .subscribe((value) => this.update(value));
    }

    ngOnDestroy() {
        this.valueSubscription?.unsubscribe();
    }

    private update(formValue: any) {
        if (this.field.component) {
            this.inputs = this.field.data ? this.field.data(formValue, this.parentFormGroup) : {};
        } else if (this.field.render) {
            this.text = this.field.render(formValue, this.parentFormGroup);
        }
    }
}
